import { APIS } from '../../../utils/apiConfig';
import { createRequestUtility } from '../../../utils/httpUtils';
import { HttpService } from '../../HttpService/HttpService';

export class OrganizationDetailsService {
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    // Initialize makeRequest with the httpService
    this.makeRequest = createRequestUtility(this.httpService);
  }

  async getUsers(company: string): Promise<any> {
    return this.makeRequest('get', APIS.GET_ORGANISATION_USERS(company), {});
  }

  async getAccountDetails(company: string): Promise<any> {
    return this.makeRequest('get', APIS.GET_ACCOUNTS_DETAILS(company), {});
  }

  async getOrgPlanDetail(company: string): Promise<any> {
    return this.makeRequest('get', APIS.GET_ORG_PLAN_DETAIL(company), {});
  }

  async updateAccountDetails(params: any): Promise<any> {
    return this.makeRequest('patch', APIS.UPDATE_ACCOUNT_DETAILS(), params);
  }

  async getOrgCloudCost(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_ORG_CLOUD_COSTS(), params);
  }

  async getTopServiceWiseCost(params: any): Promise<any> {
    return this.makeRequest(
      'post',
      APIS.GET_TOP_ORG_SERVICE_WISE_COST(),
      params
    );
  }

  async deleteAccountDetails(params: any): Promise<any> {
    return this.makeRequest('delete', APIS.DELETE_ACCOUNT_DETAILS(), params);
  }
}
